export const SHOW_FADE_CARREGANDO = 'SHOW_FADE_CARREGANDO';
export const showFadeCarregando = (showCarregando) => ({
    type: SHOW_FADE_CARREGANDO,
    payload: {
        showCarregando: showCarregando
    }
});
export const SHOW_ALERTA = 'SHOW_ALERTA';
export const showAlerta = (tipoAlerta, mensagemAlerta, timeoutAlerta) => ({
    type: SHOW_ALERTA,
    payload: {
        tipoAlerta: tipoAlerta,
        mensagemAlerta: mensagemAlerta,
        timeoutAlerta: timeoutAlerta,
        idAlerta: Math.random()
    }
});
export const RECEBIMENTO_FINALIZADO = 'RECEBIMENTO_FINALIZADO';
export const recebimentoFinalizado = (recebimentoFinalizado) => ({
    type: RECEBIMENTO_FINALIZADO,
    payload: {
        recebimentoFinalizado: recebimentoFinalizado
    }
});
export const PREENCHER_FILTRO = "PREENCHER_FILTRO";
export const preencherFiltro = (filtros) => ({
    type: PREENCHER_FILTRO,
    payload: {
        filtros: filtros
    }
});
export const PREENCHER_FAVORITOS = 'PREENCHER_FAVORITOS';
export const preencherFavoritos = (favoritos) => ({
    type: PREENCHER_FAVORITOS,
    payload: {
        favoritos: favoritos
    }
});
export const PREENCHER_LISTAGEM = "PREENCHER_LISTAGEM";
export const preencherListagem = (listagem) => ({
    type: PREENCHER_LISTAGEM,
    payload: {
        listagem: listagem
    }
});
export const ATUALIZAR_HEIGTH_FILTRO = "ATUALIZAR_HEIGTH_FILTRO";
export const atualizarHeigthFiltro = (altura) => ({
    type: ATUALIZAR_HEIGTH_FILTRO,
    payload: {
        altura: altura
    }
});
export const EXIBIR_DETALHE_ITEM = "EXIBIR_DETALHE_ITEM";
export const exibirDetalhesItem = (detalhes, topografias) => ({
    type: EXIBIR_DETALHE_ITEM,
    payload: {
        detalhes: detalhes,
        topografias: topografias
    }
});
export const ATUALIZAR_TOPOGRAFIAS = "ATUALIZAR_TOPOGRAFIAS";
export const atualizarTopografias = (topografias) => ({
    type: ATUALIZAR_TOPOGRAFIAS,
    payload: {
        topografias: topografias
    }
});
export const ATUALIZAR_DETALHES = "ATUALIZAR_DETALHES";
export const atualizarDetalhes = (detalhes) => ({
    type: ATUALIZAR_DETALHES,
    payload: {
        detalhes: detalhes
    }
});
export const VISIBILIDADE_MODAL = "VISIBILIDADE_MODAL";
export const visibilidadeModal = (visivel, itemClicado = undefined) => ({
    type: VISIBILIDADE_MODAL,
    payload: {
        visibilidade: visivel,
        itemClicado: itemClicado
    }
});
export const ATUALIZAR_TOTAIS_EXAMES = "ATUALIZAR_TOTAIS_EXAMES";
export const atualizarTotaisExames = (totalExamesAbertos, totalExamesConcluidos) => ({
    type: ATUALIZAR_TOTAIS_EXAMES,
    payload: {
        totalExamesAbertos: totalExamesAbertos,
        totalExamesConcluidos: totalExamesConcluidos
    }
});
export const MUDAR_TAB_ATIVA = "MUDAR_TAB_ATIVA";
export const mudarTabAtiva = (activeTab) => ({
    type: MUDAR_TAB_ATIVA,
    payload: {
        activeTab: activeTab
    }
});
export const PREENCHER_EXAMES_ABERTOS = "PREENCHER_EXAMES_ABERTOS";
export const preencherExamesEmAberto = (exames) => ({
    type: PREENCHER_EXAMES_ABERTOS,
    payload: {
        exames: exames
    }
});
export const PREENCHER_NAO_CONFORMIDADES = "PREENCHER_NAO_CONFORMIDADES";
export const preencherNaoConformidades = (inconformidades) => ({
    type: PREENCHER_NAO_CONFORMIDADES,
    payload: {
        inconformidades: inconformidades
    }
});
export const PREENCHER_HISTORICO_INCONFORMIDADES = "PREENCHER_HISTORICO_INCONFORMIDADES";
export const preenhcerHistoricoInconformidades = (historico) => ({
    type: PREENCHER_HISTORICO_INCONFORMIDADES,
    payload: {
        historico: historico
    }
});
export const ADICIONAR_FRASCO = "ADICIONAR_FRASCO";
export const adicionarFrasco = (frascosGravados) => ({
    type: ADICIONAR_FRASCO,
    payload: {
        frascosGravados: frascosGravados
    }
});
export const ADICIONAR_NOVO_FRASCO = "ADICIONAR_NOVO_FRASCO";
export const adicionarNovoFrasco = (frascosNovos) => ({
    type: ADICIONAR_NOVO_FRASCO,
    payload: {
        frascosNovos: frascosNovos
    }
});
export const PREENCHER_EXAMES_CONCLUIDOS = "PREENCHER_EXAMES_CONCLUIDOS";
export const preencherExamesConcluidos = (exames) => ({
    type: PREENCHER_EXAMES_CONCLUIDOS,
    payload: {
        exames: exames
    }
});
export const EXAME_SELECIONADO = "EXAME_SELECIONADO";
export const exameSelecionado = (exame) => ({
    type: EXAME_SELECIONADO,
    payload: {
        exame: exame
    }
});
export const TIPO_VINCULO_SELECIONADO = "TIPO_VINCULO_SELECIONADO";
export const tipoVinculoSelecionado = (tipo) => ({
    type: TIPO_VINCULO_SELECIONADO,
    payload: {
        tipo: tipo
    }
});
export const ESTADO_MENU_LATERAL = "ESTADO_MENU_LATERAL";
export const estadoMenuLateral = (collapsed) => ({
    type: ESTADO_MENU_LATERAL,
    payload: {
        collapsedMenu: collapsed
    }
});
export const IMPRIMI_ETIQUETA_CONTROLE = "IMPRIMI_ETIQUETA_CONTROLE";
export const imprimiEtiquetaControle = (imprimi) => ({
    type: IMPRIMI_ETIQUETA_CONTROLE,
    payload: {
        imprimiEtiquetaControle: imprimi
    }
});
export const IMPRIMI_ETIQUETA_AGORA = "IMPRIMI_ETIQUETA_AGORA";
export const imprimiEtiquetaAgora = (imprimi) => ({
    type: IMPRIMI_ETIQUETA_AGORA,
    payload: {
        imprimiEtiquetaAgora: imprimi
    }
});
export const ATUALIZAR_LISTAGEM_MULTIPLOS_EXAMES = "ATUALIZAR_LISTAGEM_MULTIPLOS_EXAMES";
export const atualizarListagemMultiplosExames = (listagem) => ({
    type: ATUALIZAR_LISTAGEM_MULTIPLOS_EXAMES,
    payload: {
        listagemMultiplosExames: listagem
    }
});
export const EXIBIR_MODAL_RECOLHIMENTO_LAUDO = "EXIBIR_MODAL_RECOLHIMENTO_LAUDO";
export const exibirModalRecolhimentoLaudo = (modalRecolhimento) => ({
    type: EXIBIR_MODAL_RECOLHIMENTO_LAUDO,
    payload: {
        modalRecolhimento: modalRecolhimento
    }
});
export const FILTRO_LOCALIZACAO_REGISTRO_MODAL_RECOLHIMENTO = "FILTRO_LOCALIZACAO_REGISTRO_MODAL_RECOLHIMENTO";
export const filtroLocalizacaoRegistroModalRecolhimento = (dados) => ({
    type: FILTRO_LOCALIZACAO_REGISTRO_MODAL_RECOLHIMENTO,
    payload: {
        filtroLocalizacaoRegistroModalRecolhimento: dados
    }
});
export const ATUALIZAR_LISTAGEM_RASTREABILIDADE = "ATUALIZAR_LISTAGEM_RASTREABILIDADE";
export const atualizarListagemRastreabilidade = (listagemRastreabilidade) => ({
    type: ATUALIZAR_LISTAGEM_RASTREABILIDADE,
    payload: {
        listagemRastreabilidade: listagemRastreabilidade
    }
});
export const ATUALIZAR_LAUDO_SELECIONADO = "ATUALIZAR_LAUDO_SELECIONADO";
export const atualizarLaudoSelecionado = (laudoSelecionado) => ({
    type: ATUALIZAR_LAUDO_SELECIONADO,
    payload: {
        laudoSelecionado: laudoSelecionado
    }
});


// WEBPACK FOOTER //
// ./src/pages/laudo/detalhesExame/detalhes.action.js